module.exports = __webpack_public_path__ + "img/email.69585001.svg";